module.exports = __webpack_public_path__ + "static/media/challenge-4.db0078f2.png";